import React from 'react';
import { connect } from 'react-redux';

import { UserAccountId } from 'api/UserAccount/model/UserAccountId';
import { ISignUpFormState } from 'shared/components/SignUpOrSignIn/SignUpForm/reducers';

import { Button } from 'shared/components/Button';
import { ConnectedEmbeddedSignUpForm, IConnectedEmbeddedSignUpFormProps } from 'shared/components/SignUpOrSignIn/EmbeddedSignUpForm/EmbeddedSignUpForm';
import { IEmbeddedSignUpFormState } from 'shared/components/SignUpOrSignIn/EmbeddedSignUpForm/reducers';
import { SignUpOptionsFormActions } from 'shared/components/SignUpOrSignIn/SignUpOptions/actions';
import { ISignUpAndLoginButtonsState } from '../SignUpAndLoginButtons/reducers';
import { UserSignUpFormActionInterfaces, UserSignUpFormActions } from './actions';

import { PathUtils } from 'shared/utils/pathUtils';

import 'shared/css/MakeItSpin.scss';
import { BevSpotDispatch } from 'shared/components/Provider';

interface IUserSignUpFormProps {
    signUpAndLoginButtonsState : ISignUpAndLoginButtonsState;
    embeddedSignUpFormState : IEmbeddedSignUpFormState;
}

interface IConnectedUserSignUpFormProps extends IUserSignUpFormProps {
    dispatch : BevSpotDispatch<IUserSignUpFormProps, { services: UserSignUpFormActionInterfaces.IServices }>;
}

class UserSignUpForm extends React.Component<IConnectedUserSignUpFormProps, object> {

    public render() {
        const {
            dispatch,
            signUpAndLoginButtonsState,
            embeddedSignUpFormState,
        } = this.props;

        if (typeof(signUpAndLoginButtonsState.loggedInUser) === 'undefined') {
            return (
                <div>
                    <span className="bevicon bevico-spinner2 make-it-spin loading-spinner"/>
                </div>
            );
        }

        if ((signUpAndLoginButtonsState.loggedInUser === null)) {
            let aboveForm : JSX.Element | null = null;
            let belowForm : JSX.Element | null = null;

            if (embeddedSignUpFormState.signUpForm.hasSuccessfullySubmitted) {
                const onClick = () => {
                    window.open(PathUtils.getAbsolutePathForRequest('/user'), '_blank');
                };

                aboveForm = (
                    <div>
                        <h5>You&rsquo;ve created your user account!</h5>
                        <div>
                            <p>Confirm you account then go to your user home to get customized content.</p>
                            <Button
                                buttonClassName="bs-psb"
                                isDisabled={ false }
                                isLoading={ false }
                                onClick={ onClick }
                            >
                                Go to user home
                            </Button>
                        </div>
                    </div>
                );
            } else {
                const onWantsToLogIn = () => {
                    dispatch(SignUpOptionsFormActions.onSetActiveForm('signInForm'));
                    dispatch(SignUpOptionsFormActions.onSetFormIsShown(true));
                };

                belowForm = (
                    <p className="small">
                        &nbsp; <br/>Already have a BevSpot account?<br/>
                        <a onClick={ onWantsToLogIn }>Log in</a> to get access.
                    </p>
                );
            }

            const connectedEmbeddedSignUpFormProps : IConnectedEmbeddedSignUpFormProps = {
                additionalFieldsAreShown : false,
                additionalRetailerFieldsAreRequired : false,
                onSuccessfulSignUp : (userAccountIdentifier : UserAccountId, signUpFormState : ISignUpFormState) => {
                    return dispatch(UserSignUpFormActions.onSuccessfulSignUp(userAccountIdentifier, signUpFormState));
                },
            };

            return (
                <div className="user-sign-up-form">
                    { aboveForm }
                    <ConnectedEmbeddedSignUpForm { ...connectedEmbeddedSignUpFormProps }/>
                    { belowForm }
                </div>
            );
        }

        return (
            <div className="user-sign-up-form">
                <p>
                    Welcome back { (signUpAndLoginButtonsState.loggedInUser.userInfo === null) ? '' : ', ' + signUpAndLoginButtonsState.loggedInUser.userInfo.firstName }!

                    &nbsp; <br/>Check out your <a href={ PathUtils.getAbsolutePathForRequest('/user') }>user dashboard</a>
                </p>
            </div>
        );
    }
}

const mapStateToProps = (state : IUserSignUpFormProps) : IUserSignUpFormProps => {
    return {
        signUpAndLoginButtonsState : state.signUpAndLoginButtonsState,
        embeddedSignUpFormState : state.embeddedSignUpFormState,
    };
};

export const ConnectedUserSignUpForm = connect<IUserSignUpFormProps, object, object, IUserSignUpFormProps>(mapStateToProps)(UserSignUpForm);
